/**
 * Header Class
 */
export class Header {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.header = document.querySelector( containerEl );
		this.mq = window.matchMedia( '(min-width: 1200px)' );
		if ( ! this.header ) {

			return false;

		}

		this.addEvents();

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		const hamburgerButton = this.header.querySelector( '.js-button-mobile-menu' );

		if ( hamburgerButton ) {

			hamburgerButton.addEventListener( 'click', ( e ) => {

				if ( ! this.mq.matches ) {

					hamburgerButton.classList.toggle( 'is-active' );
					this.header.classList.toggle( 'page-header--mobile-open' );

				}
				e.preventDefault();

			} );

		}

		// Scroll
		const ProductLP = document.querySelector( '.page-template-single-product' );

		if ( ! ProductLP ) {

			window.addEventListener( 'scroll', () => {

				const top =	 window.pageYOffset || document.documentElement.scrollTop;

				if ( top > 0 ) {

					document.body.classList.add( 'page--scrolled' );

				} else {

					document.body.classList.remove( 'page--scrolled' );

				}

			} );

		}

		// Search Overlay
		const searchButton = this.header.querySelector( '.js-button-search' );
		const searchOverlay = document.querySelector( '.js-search-overlay' );
		const searchClose = document.querySelector( '.js-button-search-close' );

		if ( searchButton ) {

			searchButton.addEventListener( 'click', ( e ) => {

				e.preventDefault();
				searchOverlay.classList.add( 'is-active' );
				document.querySelector( '.search-form__input' ).focus();

			} );

		}
		if ( searchClose ) {

			searchClose.addEventListener( 'click', ( e ) => {

				e.preventDefault();
				searchOverlay.classList.remove( 'is-active' );
				document.body.classList.remove( 'other-search' );

			} );

		}

		// Other Overlay
		const otherSearch = document.querySelector( '.js-button-other-search' );

		if ( otherSearch ) {

			otherSearch.addEventListener( 'click', ( e ) => {

				e.preventDefault();
				searchOverlay.classList.add( 'is-active' );
				document.body.classList.add( 'other-search' );

			} );

		}

		// Language Overlay

		const languageButton = this.header.querySelector( '.js-button-language' );
		const languageOverlay = document.querySelector( '.js-language-overlay' );
		let isOpened = false;

		if ( languageButton ) {

			languageButton.addEventListener( 'click', ( e ) => {

				e.preventDefault();
				languageOverlay.classList.add( 'is-active' );

				setTimeout( () => {

					isOpened = true;

				}, '250' );

			} );

		}

		document.addEventListener( 'click', ( event ) => {

			if ( languageOverlay ) {

				const isClickInside = languageOverlay.contains( event.target )

				if ( ! isClickInside && isOpened ) {

					languageOverlay.classList.remove( 'is-active' );
					isOpened = false;

				}

			}

		} );

		// Anchor Links

		const anchors = document.querySelectorAll( 'a.c-button-rounded' );

		if ( anchors.length > 0 ) {

			anchors.forEach( ( button ) => {

				button.addEventListener( 'click', ( e ) => {

					const url = e.currentTarget.getAttribute( 'href' );

					if ( url.includes( '#' ) ) {

						e.preventDefault();
						const targetId = url.slice( url.indexOf( '#' ) + 1 );

						/* eslint-disable */
                        console.log(targetId);

                        const targetElement = document.getElementById(targetId);

                        if ( targetElement ) {
                            targetElement.scrollIntoView(true);
                        }


                        /* eslint-enable */

					}

				} );

			} )

		}

		// Customer Stories Top Menu
		//const topMenu = document.querySelector( '.page-header__nav' );
		//const csLink = topMenu.querySelector( '.page-header__nav li:nth-child(3) a' );
		//const lang = document.documentElement.lang.substr( 0, 2 );
		//const host = `${ window.location.protocol }//${ window.location.host }`;
		//if ( lang !== 'en' && lang !== 'nl' ) {

		//csLink.setAttribute( 'href', `${ host }/${ lang }/customer-stories` );

		//}

		// CookieBotWidget
		const buttonCookieBot = document.querySelector( '.js-button-cookiebot' );
		if ( buttonCookieBot ) {

			buttonCookieBot.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				document.querySelector( '#CookiebotWidget' ).classList.add( 'is-visible' );
				document.querySelector( '.CookiebotWidget-logo' ).click();

			} );

		}

		// New Header Behavior
		const asideForms = document.querySelector( '.aside-forms' );
		if ( asideForms ) {

			asideForms.classList.add( 'is-visible' );

		}

		const header = document.querySelector( '.p-header' );
		const headerDropdowns = document.querySelectorAll( '.js-header-dropdown' );
		const dropdownItems = document.querySelectorAll( '.js-header-item' );
		const dropdownTabButtons = document.querySelectorAll( '.js-header-tab-button' );
		const dropdownTabs = document.querySelectorAll( '.js-header-tab' );
		const menuOpen = document.querySelector( '.js-header-menu-button-open' );
		const menuClose = document.querySelector( '.js-header-menu-button-close' );
		const menuBack = document.querySelector( '.js-header-menu-button-back' );

		const menuTop = document.querySelector( '.p-header__inner-nav-top' );
		const menuContact = document.querySelector( '.js-button-header-contact' );
		const menuControls = document.querySelector( '.p-header__inner-nav-controls' );

		const alternativeTabButtons = document.querySelectorAll( '.js-header-hover-button' );
		const alternativeTabs = document.querySelectorAll( '.js-header-hover-tab' );
		alternativeTabButtons.forEach( ( button ) => {

			button.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				const index = [ ...e.currentTarget.parentElement.children ].indexOf( e.currentTarget );

				alternativeTabButtons.forEach( ( buttonClose ) => {

					buttonClose.classList.remove( 'is-active' );

				} );

				alternativeTabs.forEach( ( tabClose ) => {

					tabClose.classList.remove( 'is-active' );

				} );

				alternativeTabButtons[ index ].classList.add( 'is-active' );
				alternativeTabs[ index ].classList.add( 'is-active' );
				header.classList.add( 'is-tabed' );

			} );

			//alternativeTabButtons[ 0 ].classList.add( 'is-active' );
			//alternativeTabs[ 0 ].classList.add( 'is-active' );

		} );

		if ( header ) {

			if ( menuTop ) {

				menuTop.addEventListener( 'mouseenter', ( ) => {

					if ( window.innerWidth > 992 ) {

						dropdownItems.forEach( ( dropdownClose ) => {

							dropdownClose.classList.remove( 'is-active' );

						} );

						alternativeTabs.forEach( ( tabClose ) => {

							tabClose.classList.remove( 'is-active' );

						} );

						header.classList.remove( 'is-searched' );
						header.classList.remove( 'is-languaged' );
						document.querySelector( '.js-header-search-overlay' ).classList.remove( 'is-active' );
						document.querySelector( '.js-header-language-overlay' ).classList.remove( 'is-active' );

					}

				} );

			}

			if ( menuContact ) {

				menuContact.addEventListener( 'mouseenter', ( ) => {

					if ( window.innerWidth > 992 ) {

						dropdownItems.forEach( ( dropdownClose ) => {

							dropdownClose.classList.remove( 'is-active' );

						} );

						alternativeTabs.forEach( ( tabClose ) => {

							tabClose.classList.remove( 'is-active' );

						} );

						header.classList.remove( 'is-searched' );
						header.classList.remove( 'is-languaged' );
						document.querySelector( '.js-header-search-overlay' ).classList.remove( 'is-active' );
						document.querySelector( '.js-header-language-overlay' ).classList.remove( 'is-active' );

					}

				} );

			}

			if ( menuControls ) {

				menuControls.addEventListener( 'mouseenter', ( ) => {

					if ( window.innerWidth > 992 ) {

						dropdownItems.forEach( ( dropdownClose ) => {

							dropdownClose.classList.remove( 'is-active' );

						} );

						alternativeTabs.forEach( ( tabClose ) => {

							tabClose.classList.remove( 'is-active' );

						} );

						header.classList.remove( 'is-searched' );
						header.classList.remove( 'is-languaged' );
						document.querySelector( '.js-header-search-overlay' ).classList.remove( 'is-active' );
						document.querySelector( '.js-header-language-overlay' ).classList.remove( 'is-active' );

					}

				} );

			}

			header.addEventListener( 'mouseleave', ( ) => {

				dropdownItems.forEach( ( dropdownClose ) => {

					dropdownClose.classList.remove( 'is-active' );

				} );

				alternativeTabs.forEach( ( tabClose ) => {

					tabClose.classList.remove( 'is-active' );

				} );

				header.classList.remove( 'is-searched' );
				header.classList.remove( 'is-languaged' );
				document.querySelector( '.js-header-search-overlay' ).classList.remove( 'is-active' );
				document.querySelector( '.js-header-language-overlay' ).classList.remove( 'is-active' );

			} );

			headerDropdowns.forEach( ( dropdown ) => {

				dropdown.addEventListener( 'mouseover', ( e ) => {

					const index = [ ...e.currentTarget.parentElement.children ].indexOf( e.currentTarget );

					if ( window.innerWidth > 992 ) {

						dropdownItems.forEach( ( dropdownClose ) => {

							dropdownClose.classList.remove( 'is-active' );

						} );

						alternativeTabs.forEach( ( tabClose ) => {

							tabClose.classList.remove( 'is-active' );

						} );

						dropdownItems[ index ].classList.add( 'is-active' );
						header.classList.remove( 'is-searched' );
						header.classList.remove( 'is-languaged' );
						document.querySelector( '.js-header-search-overlay' ).classList.remove( 'is-active' );
						document.querySelector( '.js-header-language-overlay' ).classList.remove( 'is-active' );

					}

				} );

				dropdown.addEventListener( 'click', ( e ) => {

					e.preventDefault();

					const index = [ ...e.currentTarget.parentElement.children ].indexOf( e.currentTarget );

					if ( window.innerWidth <= 992 ) {

						dropdownItems.forEach( ( dropdownClose ) => {

							dropdownClose.classList.remove( 'is-active' );

						} );

						alternativeTabs.forEach( ( tabClose ) => {

							tabClose.classList.remove( 'is-active' );

						} );

						dropdownItems[ index ].classList.add( 'is-active' );
						header.classList.add( 'is-nested' );
						header.classList.remove( 'is-searched' );
						header.classList.remove( 'is-languaged' );

					}

				} );

			} );

			dropdownTabButtons.forEach( ( button ) => {

				button.addEventListener( 'click', ( e ) => {

					e.preventDefault();

					const index = [ ...e.currentTarget.parentElement.children ].indexOf( e.currentTarget );

					dropdownTabButtons.forEach( ( buttonClose ) => {

						buttonClose.classList.remove( 'is-active' );

					} );

					dropdownTabs.forEach( ( tabClose ) => {

						tabClose.classList.remove( 'is-active' );

					} );

					dropdownTabButtons[ index ].classList.add( 'is-active' );
					dropdownTabs[ index ].classList.add( 'is-active' );
					header.classList.add( 'is-tabed' );

				} );

				dropdownTabButtons[ 0 ].classList.add( 'is-active' );
				dropdownTabs[ 0 ].classList.add( 'is-active' );

			} );

			let lastTop = 0;
			window.addEventListener( 'scroll', () => {

				const top =	 window.pageYOffset || document.documentElement.scrollTop;

				if ( top > lastTop ) {

					header.classList.remove( 'is-visible' );
					asideForms.classList.remove( 'is-visible' );

				} else {

					header.classList.add( 'is-visible' );
					asideForms.classList.add( 'is-visible' );

				}

				if ( top <= 0 ) {

					header.classList.add( 'is-visible' );
					asideForms.classList.add( 'is-visible' );

				}

				lastTop =	window.pageYOffset || document.documentElement.scrollTop;

			} );

			menuOpen.addEventListener( 'click', ( ) => {

				header.classList.add( 'is-opened' );

				dropdownTabs.forEach( ( dropdown ) => {

					dropdown.classList.remove( 'is-active' );

				} );

			} );

			menuClose.addEventListener( 'click', ( ) => {

				dropdownItems.forEach( ( dropdownClose ) => {

					dropdownClose.classList.remove( 'is-active' );

				} );

				header.classList.remove( 'is-opened' );
				header.classList.remove( 'is-nested' );
				header.classList.remove( 'is-tabed' );
				header.classList.remove( 'is-searched' );
				header.classList.remove( 'is-languaged' );

			} );

			menuBack.addEventListener( 'click', ( ) => {

				if ( header.classList.contains( 'is-tabed' ) ) {

					dropdownTabs.forEach( ( dropdown ) => {

						dropdown.classList.remove( 'is-active' );

					} );

					alternativeTabs.forEach( ( tabClose ) => {

						tabClose.classList.remove( 'is-active' );

					} );

					header.classList.remove( 'is-tabed' );
					header.classList.remove( 'is-searched' );
					header.classList.remove( 'is-languaged' );

				} else {

					dropdownItems.forEach( ( dropdownClose ) => {

						dropdownClose.classList.remove( 'is-active' );

					} );

					header.classList.remove( 'is-nested' );
					header.classList.remove( 'is-searched' );
					header.classList.remove( 'is-languaged' );

				}

			} );

			const headerSearchButton = document.querySelector( '.js-header-button-search' );
			const headerMobileSearchButton = document.querySelector( '.js-header-mobile-button-search' );

			headerSearchButton.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				dropdownItems.forEach( ( dropdownClose ) => {

					dropdownClose.classList.remove( 'is-active' );

				} );

				header.classList.add( 'is-searched' );
				header.classList.remove( 'is-languaged' );
				document.querySelector( '.js-header-search-overlay' ).classList.add( 'is-active' )
				document.querySelector( '.js-header-language-overlay' ).classList.remove( 'is-active' );

				document.querySelector( '.js-header-search-input' ).focus();

			} );

			headerMobileSearchButton.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				dropdownItems.forEach( ( dropdownClose ) => {

					dropdownClose.classList.remove( 'is-active' );

				} );

				header.classList.add( 'is-searched' );
				header.classList.remove( 'is-languaged' );

				document.querySelector( '.js-header-search-input' ).focus();

			} );

			const headerLanguageButton = document.querySelector( '.js-header-button-language' );
			const headerMobileLanguageButton = document.querySelector( '.js-header-mobile-button-language' );

			headerLanguageButton.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				dropdownItems.forEach( ( dropdownClose ) => {

					dropdownClose.classList.remove( 'is-active' );

				} );

				header.classList.remove( 'is-searched' );
				header.classList.add( 'is-languaged' );

				document.querySelector( '.js-header-search-overlay' ).classList.remove( 'is-active' )
				document.querySelector( '.js-header-language-overlay' ).classList.add( 'is-active' );

			} );

			headerMobileLanguageButton.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				dropdownItems.forEach( ( dropdownClose ) => {

					dropdownClose.classList.remove( 'is-active' );

				} );

				header.classList.remove( 'is-searched' );
				header.classList.add( 'is-languaged' );

			} );

			const buttonOpen = document.querySelector( '.js-footer-button-popup-open' );
			const buttonClose = document.querySelector( '.js-footer-button-popup-close' );
			const popup = document.querySelector( '.js-footer-popup' );

			if ( buttonOpen ) {

				buttonOpen.addEventListener( 'click', ( e ) => {

					e.preventDefault();

					if ( popup ) {

						popup.classList.add( 'is-active' );

					}

				} );

			}

			if ( buttonClose ) {

				buttonClose.addEventListener( 'click', ( e ) => {

					e.preventDefault();

					if ( popup ) {

						popup.classList.remove( 'is-active' );

					}

				} );

			}

			alternativeTabButtons.forEach( ( tabButton ) => {

				tabButton.addEventListener( 'mouseenter', ( e ) => {

					if ( window.innerWidth > 992 ) {

						alternativeTabs.forEach( ( dropdownClose ) => {

							dropdownClose.classList.remove( 'is-active' );

						} );

						alternativeTabButtons.forEach( ( dropdown ) => {

							dropdown.classList.remove( 'is-active' );

						} );

						header.classList.remove( 'is-searched' );
						header.classList.remove( 'is-languaged' );
						document.querySelector( '.js-header-search-overlay' ).classList.remove( 'is-active' );
						document.querySelector( '.js-header-language-overlay' ).classList.remove( 'is-active' );

						const index = [ ...e.currentTarget.parentElement.children ].indexOf( e.currentTarget );

						tabButton.classList.add( 'is-active' );

						alternativeTabs[ index ].classList.add( 'is-active' );

					}

				} );

			} );

		}

	}

}
